import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { TITULO, USERNAME } from './Config.js';
import { AuthProvider } from './context/AuthContext.js';
import { ClientProvider } from './context/ClientContext.js';
import App from './App.js'
import NotFoundPage from './NotFoundPage.js';

const QrMenu = () => {
  useEffect(() => {
    document.title = TITULO
  }, [])

  return (
    <AuthProvider>
        <ClientProvider>
            <BrowserRouter basename={`/${USERNAME}/`}>
                <Routes>
                    <Route path="/" element={<App />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </BrowserRouter>
        </ClientProvider>
    </AuthProvider>
  );
}

export default QrMenu;